"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.frost = void 0;
var styled_components_1 = require("styled-components");
function frost() {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n\n    @supports (backdrop-filter: none) {\n      backdrop-filter: blur(15px);\n    }\n  "], ["\n    background-color: ", ";\n\n    @supports (backdrop-filter: none) {\n      backdrop-filter: blur(15px);\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.background.frost;
    });
}
exports.frost = frost;
var templateObject_1;
